export const FirearmInsurance = () => {
    return (
        <div className="insurance-box d-flex align-items-center">
            <div className="mr-4">
                <img src={require('@Images/img_004.png').default} alt="" />
            </div>
            <div>
                <p className="title m-0">
                    The U.S. Concealed Carry Association
                </p>
                <p className="expire-date m-0">
                    <span>Expired:</span> July 22, 2021
                </p>
            </div>
        </div>
    )
}
